import { call, put, takeLatest } from "redux-saga/effects";
import { getGroup } from "../../../services/examGroup";
import { getGroupStart, getGroupSuccess, getGroupFailure } from "../reducer";

export function* getSingleGroup({ payload }) {
  const response = yield call(getGroup, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getGroupSuccess(raw));
  } else {
    yield put(getGroupFailure(message || raw.error));
  }
}

export default function* onGetExam() {
  yield takeLatest(getGroupStart.type, getSingleGroup);
}
